var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpiredRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27.1 28.7",
    style: {
      enableBackground: "new 0 0 27.1 28.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000143593528389019190020000011453902426610250113_);fill:#D64527;}\n\t.st1{clip-path:url(#SVGID_00000063604324058982366710000007727878260200376480_);fill:#D64527;}\n\t.st2{clip-path:url(#SVGID_00000098913781648773389240000017547741635457656211_);fill:#8C9D9D;}\n\t.st3{clip-path:url(#SVGID_00000126308204908212209000000005239177773486924462_);fill:#8C9D9D;}\n\t.st4{clip-path:url(#SVGID_00000162317853469024356280000017894377371945498298_);fill:#D64527;}\n\t.st5{clip-path:url(#SVGID_00000092451860889522507140000007268367160746166435_);fill:#D64527;}\n\t.st6{clip-path:url(#SVGID_00000157293790535903599760000003278457551326123392_);fill:#D64527;}\n\t.st7{clip-path:url(#SVGID_00000098186725332146633830000006418329752307778209_);fill:#8C9D9D;}\n\t.st8{clip-path:url(#SVGID_00000149350799820353996780000017813247326889419153_);fill:#8C9D9D;}\n\t.st9{clip-path:url(#SVGID_00000023959689549069825350000017425544910692616375_);fill:#8C9D9D;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M-151-64.5h-4.8V-65c0-1.3,1.1-2.3,2.4-2.3c1.3,0,2.4,1,2.4,2.3L-151-64.5z M-152.9-61v0.6 c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5V-61c-0.3-0.2-0.5-0.4-0.5-0.8c0-0.5,0.4-0.9,1-0.9s1,0.4,1,0.9 C-152.4-61.5-152.6-61.2-152.9-61z M-153.4-68.2c-1.8,0-3.3,1.4-3.3,3.2v0.5h-0.5c-0.3,0-0.5,0.2-0.5,0.5v5.5 c0,0.3,0.2,0.5,0.5,0.5h7.6c0.3,0,0.5-0.2,0.5-0.5v-5.5c0-0.3-0.2-0.5-0.5-0.5h-0.5V-65C-150.1-66.7-151.6-68.2-153.4-68.2 L-153.4-68.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000001634261318305254910000002896920813219300755_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: -158.7,
    y: -69.2,
    style: {
      clipPath: "url(#SVGID_00000001634261318305254910000002896920813219300755_)",
      fill: "#D64527"
    },
    width: 10.6,
    height: 12
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000183961097555799619820000000524334905678776979_",
    d: "M-140.7-65.4c-0.2-0.2-0.5-0.2-0.6,0l-2,2.1 c-0.1-5.4-4.4-9.8-9.6-9.8c-5.3,0-9.6,4.5-9.6,10s4.3,10,9.6,10c2.5,0,4.9-1,6.7-2.9c0.2-0.2,0.2-0.5,0-0.7 c-0.2-0.2-0.5-0.2-0.6,0c-1.6,1.7-3.8,2.6-6.1,2.6c-4.8,0-8.7-4.1-8.7-9c0-5,3.9-9,8.7-9c4.7,0,8.6,3.9,8.7,8.8l-2-2 c-0.2-0.2-0.5-0.2-0.6,0c-0.2,0.2-0.2,0.5,0,0.7l2.7,2.9c0.1,0.1,0.2,0.1,0.3,0.1s0.2,0,0.3-0.1l2.7-2.9 C-140.5-64.9-140.5-65.2-140.7-65.4L-140.7-65.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000100343286611994762170000001825886246417737892_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183961097555799619820000000524334905678776979_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: -163.6,
    y: -74.2,
    style: {
      clipPath: "url(#SVGID_00000100343286611994762170000001825886246417737892_)",
      fill: "#D64527"
    },
    width: 24,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000065071938093964619390000013215194453319643578_",
    d: "M-151,19.5h-4.8V19c0-1.3,1.1-2.3,2.4-2.3 c1.3,0,2.4,1,2.4,2.3L-151,19.5z M-152.9,23v0.6c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5V23c-0.3-0.2-0.5-0.4-0.5-0.8 c0-0.5,0.4-0.9,1-0.9s1,0.4,1,0.9C-152.4,22.5-152.6,22.8-152.9,23z M-153.4,15.8c-1.8,0-3.3,1.4-3.3,3.2v0.5h-0.5 c-0.3,0-0.5,0.2-0.5,0.5v5.5c0,0.3,0.2,0.5,0.5,0.5h7.6c0.3,0,0.5-0.2,0.5-0.5v-5.5c0-0.3-0.2-0.5-0.5-0.5h-0.5V19 C-150.1,17.3-151.6,15.8-153.4,15.8L-153.4,15.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178904937192303300440000017061367062693708425_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065071938093964619390000013215194453319643578_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: -158.7,
    y: 14.8,
    style: {
      clipPath: "url(#SVGID_00000178904937192303300440000017061367062693708425_)",
      fill: "#8C9D9D"
    },
    width: 10.6,
    height: 12
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000140711947698898208910000018234249611159195322_",
    d: "M-140.7,18.6c-0.2-0.2-0.5-0.2-0.6,0l-2,2.1 c-0.1-5.4-4.4-9.8-9.6-9.8c-5.3,0-9.6,4.5-9.6,10s4.3,10,9.6,10c2.5,0,4.9-1,6.7-2.9c0.2-0.2,0.2-0.5,0-0.7 c-0.2-0.2-0.5-0.2-0.6,0c-1.6,1.7-3.8,2.6-6.1,2.6c-4.8,0-8.7-4.1-8.7-9c0-5,3.9-9,8.7-9c4.7,0,8.6,3.9,8.7,8.8l-2-2 c-0.2-0.2-0.5-0.2-0.6,0c-0.2,0.2-0.2,0.5,0,0.7l2.7,2.9c0.1,0.1,0.2,0.1,0.3,0.1s0.2,0,0.3-0.1l2.7-2.9 C-140.5,19.1-140.5,18.8-140.7,18.6L-140.7,18.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011719417770927652640000012554883366228227515_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000140711947698898208910000018234249611159195322_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: -163.6,
    y: 9.8,
    style: {
      clipPath: "url(#SVGID_00000011719417770927652640000012554883366228227515_)",
      fill: "#8C9D9D"
    },
    width: 24,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000086659040411682304390000010205625306504232345_",
    d: "M7.2,12.2c0.2,0.2,0.5,0.2,0.5,0.1L9,11.1 c0,0,0.1,0,0.1,0c0.5,0,0.9-0.4,0.9-0.9c0-0.3-0.1-0.5-0.3-0.7L9.5,6.7c0-0.2-0.2-0.3-0.4-0.3c-0.3,0-0.4,0.2-0.4,0.3L8.6,9.5 c-0.2,0.2-0.4,0.4-0.4,0.7c0,0,0,0.1,0,0.1l-1.1,1.3C7.1,11.7,7,11.9,7.2,12.2L7.2,12.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000174588742370390238570000013877066064942845062_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000086659040411682304390000010205625306504232345_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5.4,
    style: {
      clipPath: "url(#SVGID_00000174588742370390238570000013877066064942845062_)",
      fill: "#D64527"
    },
    width: 5.1,
    height: 8
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000031209564156530300840000002765111563783148162_",
    d: "M15.7,21.8c-0.2,0.2-0.5,0.3-0.8,0.3 c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.2-0.4-0.5-0.4-0.8c0-0.3,0.2-0.6,0.4-0.8c0.2-0.2,0.5-0.3,0.8-0.3c0.3,0,0.6,0.1,0.8,0.3 c0.2,0.2,0.4,0.5,0.4,0.8C16.1,21.4,16,21.6,15.7,21.8z M14.1,14.2c0.2-0.2,0.5-0.4,0.8-0.4c0.4,0,0.6,0.2,0.8,0.4 c0.2,0.2,0.3,0.5,0.3,0.8c0,0.3-0.5,2.5-0.6,4.2h-1.2c-0.2-1.6-0.6-3.8-0.6-4.2C13.7,14.7,13.8,14.4,14.1,14.2z M22.7,21.8 l-6.4-10.5c-0.8-1.3-2.1-1.3-2.8,0L7.1,21.8c-0.8,1.3-0.2,2.3,1.4,2.3h12.7C22.8,24.1,23.4,23,22.7,21.8L22.7,21.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000055688594392368290890000009033529269129775273_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031209564156530300840000002765111563783148162_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 5.4,
    y: 8.9,
    style: {
      clipPath: "url(#SVGID_00000055688594392368290890000009033529269129775273_)",
      fill: "#D64527"
    },
    width: 19.1,
    height: 16.2
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000181060348763025451140000000824593520471361157_",
    d: "M9.5,16.4l1.1-1.8c-0.5,0.2-1,0.2-1.5,0.2 c-2.5,0-4.6-2.1-4.6-4.6s2.1-4.6,4.6-4.6c2.4,0,4.4,1.8,4.6,4.2c0.3-0.2,0.8-0.4,1.2-0.4h0.3c-0.4-3.1-3-5.4-6.1-5.4 C5.8,4.1,3,6.9,3,10.2c0,3.4,2.8,6.2,6.1,6.2H9.5L9.5,16.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085229536352890156320000013337658470257604224_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181060348763025451140000000824593520471361157_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3.1,
    style: {
      clipPath: "url(#SVGID_00000085229536352890156320000013337658470257604224_)",
      fill: "#D64527"
    },
    width: 14.2,
    height: 14.3
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000061432720427012465320000001279087914133615746_",
    d: "M-159.3-23.1c0.2,0.2,0.5,0.2,0.5,0.1l1.2-1.1 c0,0,0.1,0,0.1,0c0.5,0,0.9-0.4,0.9-0.9c0-0.3-0.1-0.5-0.3-0.7l-0.2-2.8c0-0.2-0.2-0.3-0.4-0.3c-0.3,0-0.4,0.2-0.4,0.3l-0.1,2.8 c-0.2,0.2-0.4,0.4-0.4,0.7c0,0,0,0.1,0,0.1l-1.1,1.3C-159.5-23.6-159.6-23.3-159.3-23.1L-159.3-23.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150813352117272304100000004199192112083477163_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000061432720427012465320000001279087914133615746_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: -160.6,
    y: -29.9,
    style: {
      clipPath: "url(#SVGID_00000150813352117272304100000004199192112083477163_)",
      fill: "#8C9D9D"
    },
    width: 5.1,
    height: 8
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000084506822899868152740000007199051723313126839_",
    d: "M-150.8-13.4c-0.2,0.2-0.5,0.3-0.8,0.3 c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.2-0.4-0.5-0.4-0.8c0-0.3,0.2-0.6,0.4-0.8c0.2-0.2,0.5-0.3,0.8-0.3c0.3,0,0.6,0.1,0.8,0.3 c0.2,0.2,0.4,0.5,0.4,0.8C-150.4-13.9-150.6-13.6-150.8-13.4z M-152.5-21.1c0.2-0.2,0.5-0.4,0.8-0.4c0.4,0,0.6,0.2,0.8,0.4 c0.2,0.2,0.3,0.5,0.3,0.8c0,0.3-0.5,2.5-0.6,4.2h-1.2c-0.2-1.6-0.6-3.8-0.6-4.2C-152.9-20.6-152.7-20.9-152.5-21.1z M-143.9-13.5 l-6.4-10.5c-0.8-1.3-2.1-1.3-2.8,0l-6.3,10.5c-0.8,1.3-0.2,2.3,1.4,2.3h12.7C-143.7-11.2-143.1-12.2-143.9-13.5L-143.9-13.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000177483150277930425300000008744425038247808436_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000084506822899868152740000007199051723313126839_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: -161.2,
    y: -26.3,
    style: {
      clipPath: "url(#SVGID_00000177483150277930425300000008744425038247808436_)",
      fill: "#8C9D9D"
    },
    width: 19.1,
    height: 16.2
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000153673858406221372440000006913198068786130867_",
    d: "M-157-18.9l1.1-1.8c-0.5,0.2-1,0.2-1.5,0.2 c-2.5,0-4.6-2.1-4.6-4.6c0-2.5,2.1-4.6,4.6-4.6c2.4,0,4.4,1.8,4.6,4.2c0.3-0.2,0.8-0.4,1.2-0.4h0.3c-0.4-3.1-3-5.4-6.1-5.4 c-3.4,0-6.1,2.8-6.1,6.2s2.8,6.2,6.1,6.2H-157L-157-18.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075125370635360401360000005834199349001912967_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000153673858406221372440000006913198068786130867_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: -164.6,
    y: -32.2,
    style: {
      clipPath: "url(#SVGID_00000075125370635360401360000005834199349001912967_)",
      fill: "#8C9D9D"
    },
    width: 14.2,
    height: 14.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredRed);
export default __webpack_public_path__ + "static/media/expired-red.61460619b16c59291bb4681082c8a485.svg";
export { ForwardRef as ReactComponent };